export default "__VITE_ASSET__DShZsF3D__"